import { render, staticRenderFns } from "./BoletaIssuanceDialog.vue?vue&type=template&id=60fa020a&scoped=true&"
import script from "./BoletaIssuanceDialog.vue?vue&type=script&lang=js&"
export * from "./BoletaIssuanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoletaIssuanceDialog.vue?vue&type=style&index=0&id=60fa020a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa020a",
  null
  
)

export default component.exports